import { render, staticRenderFns } from "./deliveryOne.vue?vue&type=template&id=5e1b26f1"
import script from "./deliveryOne.vue?vue&type=script&lang=js"
export * from "./deliveryOne.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports